import { isMobile } from "react-device-detect";
import React from "react";
import Nav1Large from "../Header/Navbar1Web";
import Nav1Small from "../Header/Navbar1Mobile";

class Navbar1Combine extends React.Component {
  renderContent = () => {
    if (isMobile) {
      return (
        <div>
          <Nav1Small />
        </div>
      );
    }
    return (
      <div>
        <Nav1Large />
      </div>
    );
  };
  render() {
    return this.renderContent();
  }
}
export default Navbar1Combine;
